var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpsRatingUnlikely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 100,
    viewBox: "0 0 104 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1867 74.0141C36.6579 74.0141 36.123 73.863 35.6542 73.5551C34.4222 72.7358 34.1157 71.1088 34.9631 69.9176C38.4909 64.9612 44.675 61.9746 51.5023 61.9223C58.4256 61.8816 64.76 64.8508 68.4621 69.8828C69.3276 71.0623 69.0391 72.6951 67.8251 73.526C66.6051 74.3627 64.9163 74.0838 64.0569 72.9101C61.3765 69.2669 56.6828 67.1053 51.5443 67.146C46.484 67.1809 41.9526 69.325 39.4224 72.8752C38.8996 73.6132 38.0521 74.0083 37.1927 74.0083L37.1867 74.0141Z",
    fill: "#3B6CCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.853 45.5446C36.1907 45.4494 38.8165 42.7563 38.718 39.5294C38.6196 36.3024 35.8341 33.7636 32.4964 33.8589C29.1588 33.9541 26.533 36.6472 26.6314 39.8741C26.7299 43.1011 29.5154 45.6399 32.853 45.5446Z",
    fill: "#3B6CCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7256 45.5346C74.0647 45.5346 76.7716 42.9175 76.7716 39.6892C76.7716 36.4608 74.0647 33.8438 70.7256 33.8438C67.3865 33.8438 64.6797 36.4608 64.6797 39.6892C64.6797 42.9175 67.3865 45.5346 70.7256 45.5346Z",
    fill: "#3B6CCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.715 100C23.1981 100 0 77.5712 0 50C0 22.4288 23.1981 0 51.715 0C80.2319 0 103.43 22.4288 103.43 50C103.43 77.5712 80.2319 100 51.715 100ZM51.715 5.23533C26.185 5.23533 5.40889 25.3167 5.40889 50.0058C5.40889 74.6949 26.179 94.7763 51.715 94.7763C77.251 94.7763 98.0211 74.6949 98.0211 50.0058C98.0211 25.3167 77.251 5.23533 51.715 5.23533Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsRatingUnlikely);
export default __webpack_public_path__ + "static/media/nps-rating-unlikely.7e80499a6ec161055de44e56fa8bf2d9.svg";
export { ForwardRef as ReactComponent };